// src/components/AppLayout.jsx
import { useContext } from "react";
import { ThemeContext } from "../context/ThemeContext";
import { useThemeColors } from "../context/ThemeColorContext";
import HeadMeta from "./HeadMeta";

const AppLayout = ({ children }) => {
  const { darkMode } = useContext(ThemeContext);
  const {
    darkPrimary,
    lightPrimary,
    lightText
  } = useThemeColors();

  return (
    <>
      <HeadMeta />
      <div
        className="min-h-screen transition-colors"
        style={{
          backgroundColor: darkMode ? darkPrimary : lightPrimary,
          color: darkMode ? "#fff" : lightText,
        }}
      >
        {children}
      </div>
    </>
  );
};

export default AppLayout;
